import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Landing from './components/landing'; 
import Login from './components/Login';
import SignUpPage from './components/SignUpPage'
import Dashboard from './components/dashboard/Dashboard';
import AddUser from './components/dashboard/AddUser';
import Customers from './components/dashboard/Customers';
import NotFound from './components/NotFound';
import AuthGuard from './guards/auth.guard';
import PrivacyPolicy from './components/PrivacyPolicy';
import Support from './components/Support';
import DeleteAccount from './components/DeleteAccount';
import JoinAlbum from './components/JoinAlbum';
import './App.css'


const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signUp" element={<SignUpPage />} />
      <Route path="/dashboard" element={
        <AuthGuard>
          <Dashboard />
        </AuthGuard>
      } />
      <Route path="/dashboard/add-user" element={
        <AuthGuard>
          <AddUser />
        </AuthGuard>
      } />
      <Route path="/dashboard/customers" element={
        <AuthGuard>
          <Customers />
        </AuthGuard>
      } />
      <Route path="/delete-account" element={<DeleteAccount />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/support" element={<Support />} />
      <Route path="/joinAlbum/:code" element={<JoinAlbum />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
